<template lang='pug'>
  div
    bionic-metrics-page-loading(v-if='loading')
    v-container#loadTestsRunDetail(fluid v-if='!loading && results')
      v-row(dense)
        v-col(cols='12' md='6' v-for='test in loadTest.tests' :key='test.guid')
          bionic-metrics-load-test-card(:loadTest='loadTest' :test='test' :result='results[test.guid]' :runGuid='runGuid')
</template>

<script>
import {get} from 'lodash';
import {mapMutations} from 'vuex';
import MessageMixin from '@/mixins/message.mixin';
import LoadTest from '@/api/loadTest';
import BionicMetricsPageLoading from '@/components/PageLoading';
import BionicMetricsLoadTestCard from '@/components/LoadTestCard';

export default {
  name: 'LoadTest.vue',
  components: {BionicMetricsLoadTestCard, BionicMetricsPageLoading},
  mixins: [MessageMixin],
  props: {
    guid: {
      required: true,
      type: String
    },
    runGuid: {
      required: true,
      type: String
    }
  },
  async mounted() {
    await this.load();
    await this.listen();
  },
  computed: {},
  methods: {
    async load() {
      try {
        this.loading = true;
        this.loadTest = await LoadTest.get(this.guid);
        this.results = await LoadTest.getRun(this.guid, this.runGuid);
      } catch (error) {
        return this.abort();
      } finally {
        this.loading = false;
      }
    },
    async listen() {
      console.log('Listening');
      await this.addChannel(this.runGuid);
    },
    onMessage(data) {
      const type = get(data, 'message.type');
      if (this.debug) console.log(`TestStatus.vue "${type}" ${JSON.stringify(data)}`);
      if (type === 'testStatus') return this.updateTestStatus(data.message);
    },
    updateTestStatus(message) {
      console.log(message);
      const {testGuid, status, isRunning} = message;
      const key = testGuid;
      if (isRunning) this.results[key].running++;
      else this.results[key].running--;
      if (status === 'PASSING' && !isRunning) this.results[key].passing++;
      if ((status === 'FAILING' || status === 'FAULT') && !isRunning) this.results[key].failing++;
    },
    updateBreadcrumb() {
      this.setBreadcrumb([
        {text: 'Load Tests', to: '/load-tests'},
        {
          text: this.loadTest.name,
          to: `/load-test/${this.loadTest.guid}`,
          exact: true
        }, {
          text: 'Results'
        }]);
    },
    ...mapMutations({
      setBreadcrumb: 'setBreadcrumb'
    })
  },
  watch: {
    'loadTest.name': {
      handler: function () { // eslint-disable-line
        this.updateBreadcrumb();
      },
      deep: true
    }
  },
  data() {
    return {
      debug: false,
      loading: false,
      loadTest: null,
      results: null,
      messageKey: 'load-test-run'
    };
  }
};
</script>

<style scoped>
</style>
